import { HashRouter, Route, Routes } from 'react-router-dom';
import { TopLoader } from './components/TopLoader.js';
import './App.css';
import './css/nprogress.css';
import Home from './pages/Home.js';
import Register from './pages/Register.js';
import AddPost from './pages/AddPost.js';
import Buy from './pages/Buy.js';
import Info from './pages/Info.js';
import Leaderboard from './pages/leaderboard.js';
import About from './pages/About.js';
import Search from './pages/Search.js';
import SinglePost from './pages/SinglePost.js';
import Reply from './pages/Reply.js';
import User from './pages/User.js';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Check for saved theme preference or system preference
    const savedTheme = localStorage.getItem('theme') || 
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <HashRouter>
      <div className="App">
        <TopLoader />
        <div className="app-content">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path="post" element={<SinglePost />} />
            <Route path="register" element={<Register />} />
            <Route path="add" element={<AddPost />} />
            <Route path="buy" element={<Buy />} />
            <Route path="info" element={<Info />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="about" element={<About />} />
            <Route path="search" element={<Search />} />
            <Route path="user" element={<User />} />
            <Route path="reply" element={<Reply />} />
          </Routes>
        </div>
      </div>
    </HashRouter>
  );
}

export default App;
